export default {
    listMailDraft: [],
    searchFilter: null,
    preMailDraft: [],
    mode: false,
}